import { useContext, createContext } from 'react';
import noop from 'utils/noop';

export interface ModalContextState<T = string> {
  modalState: T | null;
  showModal: (modalState: T) => void;
  hideModal: () => void;
  mediumRef?: any;
}

export const defaultState: ModalContextState<any> = {
  modalState: null,
  showModal: noop,
  hideModal: noop,
  mediumRef: null,
};

export const ModalContext = createContext(defaultState);
export const useModalContext = <T>() => useContext<ModalContextState<T>>(ModalContext);
